/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Action_KeepInputs */

const cs_gdpr_action_keep = /** @type {(inputs: Gdpr_Action_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponechání`)
};

const en_gdpr_action_keep = /** @type {(inputs: Gdpr_Action_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kept`)
};

/**
* | output |
* | --- |
* | "Kept" |
*
* @param {Gdpr_Action_KeepInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_action_keep = /** @type {((inputs?: Gdpr_Action_KeepInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Action_KeepInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_action_keep(inputs)
	return cs_gdpr_action_keep(inputs)
});